import React, { useEffect, useState } from "react";
import "../style.scss";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { icon } from "@fortawesome/fontawesome-svg-core/import.macro";
import logo from "../img/logo.png";
import SideNav from "components/SideNav";
import { collection, query, where, getDocs } from "firebase/firestore";
import { db } from "../firebase/firebase";
import background_image from "../img/take-notes.jpg";
import LoadingBar from "react-top-loading-bar";
import Shimmer from "react-shimmer-effect";
import { getAuth, onAuthStateChanged, signOut } from "firebase/auth";

export default function Plans() {
  const [planList, setPlanList] = useState(<></>);
  const [progress, setProgress] = useState(30);
  const [isLoading, setIsLoading] = useState(true);

  const loadPermission = async (urlVar) => {
    const q = query(collection(db, "users"), where("__name__", "==", urlVar));

    const querySnapshot = await getDocs(q);

    querySnapshot.forEach((doc) => {
      getData(doc.data().isAdmin, doc.data().permission_groups);
    });
  };

  useEffect(() => {
    const getUser = async () => {
      const auth = await getAuth();

      onAuthStateChanged(auth, (user) => {
        if (user) {
          loadPermission(user.uid);
        } else {
          window.location.replace("/");
        }
      });
    };
    getUser();
  }, []);

  const getData = async (isAdmin, permissions) => {
    var q;
    const elements = [<></>];

    if (isAdmin) {
      q = query(collection(db, "plans"));
    } else {
      try {
        q = query(
          collection(db, "plans"),
          where("permission_groups", "array-contains-any", permissions)
        );
      } catch (error) {
        elements.push(
          <h3 style={{ color: "#000", textAlign: "center" }}>
            {"Keine Trainingspläne gefunden."}
          </h3>
        );

        elements.push(
          <a href="createplan">
            <div className="flex-row">
              <i style={{ color: "#7a3260" }} className="fa-solid fa-plus">
                <FontAwesomeIcon
                  icon={icon({ name: "plus", style: "solid" })}
                />
              </i>
              <div className="right">
                <h3 style={{ margin: 0 }}>Trainingsplan hinzufügen</h3>
              </div>
            </div>
          </a>
        );

        setPlanList(elements);
        setIsLoading(false);

        console.log("error:::");
        console.log(error);
      }
    }

    const querySnapshot = await getDocs(q);

    querySnapshot.forEach((doc) => {
      var refString = "editplan?planid=" + doc.id;

      setProgress(50);

      if (doc?.data()?.isDeleted == false) {
      } else {
        setProgress(70);

        elements.push(
          <a
            className="flex-row"
            href={refString}
            style={{
              backgroundImage: `linear-gradient(to bottom, rgba(0, 0, 0, 0.2), rgba(0, 0, 0, 0.4)), url(${background_image})`,
              backgroundRepeat: "no-repeat",
              backgroundSize: "cover",
            }}
          >
            <i style={{ color: "#fff" }} className="fa-solid fa-check">
              <FontAwesomeIcon icon={icon({ name: "check", style: "solid" })} />
            </i>
            <div className="right">
              <h3 style={{ color: "#fff" }}>{doc.data().name_de}</h3>
              {doc.data().desc_de.length > 110 ? (
                <>
                  <p style={{ color: "#fff" }}>
                    {doc.data().desc_de.substring(0, 100) + "..."}
                  </p>
                </>
              ) : (
                <p style={{ color: "#fff" }}>{doc.data().desc_de}</p>
              )}
            </div>
          </a>
        );
      }
    });

    setProgress(100);

    elements.push(
      <a href="createplan">
        <div className="flex-row">
          <i style={{ color: "#7a3260" }} className="fa-solid fa-plus">
            <FontAwesomeIcon icon={icon({ name: "plus", style: "solid" })} />
          </i>
          <div className="right">
            <h3 style={{ margin: 0 }}>Trainingsplan hinzufügen</h3>
          </div>
        </div>
      </a>
    );

    setPlanList(elements);
    setIsLoading(false);
  };

  const RenderLoading = () => (
    <>
      <a
        className="flex-row"
        style={{
          backgroundColor: "fff", //"#fff",
        }}
        // style={{
        //   backgroundImage: `linear-gradient(to bottom, rgba(0, 0, 0, 0.2), rgba(0, 0, 0, 0.4)), url(${background_image})`,
        //   backgroundRepeat: "no-repeat",
        //   backgroundSize: "cover",
        // }}
      >
        <i style={{ color: "#000" }} className="fa-solid fa-check">
          <Shimmer>
            <div
              style={{
                height: "56px",
                width: "56px",
                borderRadius: "50%",
                backgroundColor: "#eee",
              }}
              // className="grid"
            ></div>
          </Shimmer>

          {/* <FontAwesomeIcon icon={icon({ name: "check", style: "solid" })} /> */}
        </i>

        <a
          style={{
            width: "100%",
            marginLeft: 70,
            padding: 0,
            gap: 0,
            gridTemplateColumns: "none",
            backgroundColor: "#fff",
          }}
          className="grid"
        >
          <Shimmer>
            <div
              style={{
                width: "100%",
                height: 20,
                backgroundColor: "#eee",
                borderRadius: 999,
                marginBottom: 25,
              }}
              className="grid"
            ></div>
          </Shimmer>

          <Shimmer>
            <div
              style={{
                width: "100%",
                height: 15,
                backgroundColor: "#eee",
                borderRadius: 999,
                marginBottom: 10,
              }}
            ></div>
          </Shimmer>
          <Shimmer>
            <div
              style={{
                width: "100%",
                height: 15,
                backgroundColor: "#eee",
                borderRadius: 999,
              }}
            ></div>
          </Shimmer>
        </a>
      </a>
    </>
  );

  const Content = () => (
    <section className="home-section">
      <div className="text">
        Trainingspläne
        <a
          href="createplan"
          style={{
            color: "white",
            marginTop: 50,
            marginLeft: 15,
          }}
          className="fa-solid fa-plus"
        >
          <FontAwesomeIcon
            style={{
              backgroundColor: "#7a3260",
              padding: 5,
              borderRadius: 999,
              width: "15px",
              height: "15px",
            }}
            icon={icon({ name: "plus", style: "solid" })}
          />
        </a>
      </div>

      {/* plans */}
      <section style={{ paddingTop: 50 }} className="my-plans" id="plans">
        <div className="container">
          <h2 style={{ marginBottom: "40px" }}>Aktive Pläne</h2>
          <div style={{}} className="grid plan-list" id="plan-list">
            {isLoading ? (
              <>
                {RenderLoading()}
                {RenderLoading()}
                {RenderLoading()}
              </>
            ) : (
              <>{planList}</>
            )}
          </div>
        </div>
      </section>
    </section>
  );

  const selPage = "plans";

  return (
    <>
      <head>
        <link
          href="https://unpkg.com/boxicons@2.0.7/css/boxicons.min.css"
          rel="stylesheet"
        />
      </head>
      {/* <LoadingBar
        color="tranparent"//"#7a3260"
        progress={progress}
        onLoaderFinished={() => {
          setProgress(0);
          setIsLoading(false);
        }}
        waitingTime={100}
        // continuousStart={0,0}
      /> */}

      {SideNav({
        Content,
        selPage,
      })}
    </>
  );
}
